<template>
    <div class="scenarioReference-manage">
        <Paper class="scenarioReference-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="tableList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="导入"
                        v-has="authorityCode.import"
                        @click="importOpera">
                        导入
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="导出"
                        :disabled="tableList.totalData.length === 0"
                        v-has="authorityCode.export"
                        @click="exportOpera">
                        导出
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="refresh"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                        icon="iconfont icon-list_install"
                        type="primary"
                        size="mini"
                        :title="'列配置'"
                        @click="showColumnConfigDialog"
                        plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        key="attendanceRulesSettings"
                        v-loading="tableList.tableLoading"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="tableList.totalData"
                        :control="false"
                        :allowRowClick="false"
                        @selection-change="handleSelectionChange"
                    >
                    </edit-table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        :page-size.sync="tableList.pageSize"
                        @size-change="tableList.sizeChange"
                        :current-page.sync="tableList.pageNo"
                        @current-change="tableList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>

        <!-- 表格列配置弹框 -->
        <column-config
            :pageID="config.name"
            :initColumns="config.columns"
            ref="otpColumnConfig"
            @header-change="config.columns = $event"
        />

        <!-- 导入弹窗 -->
        <addFileDialog
            ref="fileDialogRef"
            :config="import_Config"
            @uploadSuccessHandle="refresh"
          >
        </addFileDialog>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { Message } from 'element-ui';
import searchBox from '@/components/lots/searchBox';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getList, exportApi } from '@/modules/mdm/api/targetModdeules/scenarioReference.js';
import { config as configStatic } from './config';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import { importConfig } from './import';
import columnConfig from '@/components/lots/columnConfig/Index';
import _ from 'lodash';

export default {
    name: 'scenarioReference',
    components: {
        Paper,
        searchBox,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        addFileDialog,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 按钮权限
        const authorityCode = reactive(btnAuthority.scenarioReference);

        const config = reactive(configStatic);
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        onMounted(async() => {
            const queryParams = { dataYear: new Date().getFullYear().toString() };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        });

        class ListClass extends AdvanceListClass {
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            ...v
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getList // 查询接口
            },
            pageSize: 20
        });

        const exportOpera = () => {
            const excelTitleList = config.columns?.filter(item => !item.hiddenColumn).map(item => ({
                name: item.label,
                property: item.prop
            })) ?? [];
            const { value } = tableList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            // 配置了那些字段就传那些
            newData.excelTitleList = excelTitleList;
            exportApi(newData).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const import_Config = ref({});
        // 打开导入弹窗
        const importOpera = () => {
            import_Config.value = importConfig;
            setupContext.refs.fileDialogRef.openImport();
        };

        // 选择项
        const selectedRows = ref([]);
        const handleSelectionChange = (val) => {
            selectedRows.value = val;
        };

        // 刷新列表
        const refresh = () => {
            tableList.getList();
        };

        return {
            tableList,
            config,
            exportOpera,
            importOpera,
            handleSelectionChange,
            authorityCode,
            import_Config,
            selectedRows,
            refresh,
            showColumnConfigDialog,
            otpColumnConfig
        };
    }
};
</script>

<style lang="less">
.scenarioReference-manage {
    width: 100%;

    .layout-content {
        box-shadow: none
    }

    .list-layout {
        padding-top: 20px;
    }

    .scenarioReference-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .scenarioReference-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .scenarioReference-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.scenarioReference-manage-paper {
        padding: 0px 20px 20px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}
</style>
